/** @todo Add locize */

const BASIC_CANDIDATE_FIELDS = [
  { id: "TEXT", body: "Neues Feld hinzufügen" },
  { id: "CV", body: "Lebenslauf" },
  { id: "OTHER_FILES", body: "Andere Dokumente" }
];

const QUESTIONS_TYPES = {
  FORM_QUESTION: "FORM_QUESTION",
  CHATBOT_QUESTION: "CHATBOT_QUESTION"
};

module.exports = { BASIC_CANDIDATE_FIELDS, QUESTIONS_TYPES };
